import React, { useState, useCallback, useEffect } from "react";

import {
    Box,
    Paper,
    Divider,
    TextField,
    Grid,
    Typography,
    Switch,
    FormControlLabel,
    styled,
    Card,
    Chip
} from '@mui/material';

import { green, grey, red } from "@mui/material/colors";

import { useNavigate, useParams } from "react-router-dom";
// import { useFormik } from 'formik';
import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import CommonSectionHeader from "../../common/CommonSectionHeader";
import CommonRestricted from '../../common/CommonRestricted';
import CommonJsonViewer from "../../common/CommonJsonViewer";

import { useSchedulers, schedulerTypes, targetTypes } from '../../../hooks/api/useSchedulers';
import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { useSystemRoutes, routeTypes } from '../../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../hooks/usePermissions';

import { useAppContextFeatures } from "../../../context/AppContext";

import RequestStatusBadge from "./section/RequestStatusBadge";

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export const StyledIcon = styled(Box)({
    width: 100,
    height: 100,
    opacity: 0.1,
    //   backgroundColor: "green",
    //   color: 'inherit',
    //   display: 'flex',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
});

const StyledLabel = styled(Typography)(({ theme }) => ({
    fontSize: '0.9rem',
    fontWeight: 800
}))

const StyledContent = styled(Typography)(({ theme }) => ({
    fontSize: '0.9rem'
}))

const StyledDivider = styled(Divider)(({ theme }) => ({
    mt: 1,
    mb: 0,
    borderStyle: 'dashed'
}))

export default function ViewRequest({
    routeType
}) {

    const { id } = useParams();

    const { promptMessage } = useSystemPrompt();
    const { isLoading, get } = useSchedulers({ schedulerType: schedulerTypes.schedulerRequest, targetType: targetTypes.schedulerRequest });
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.scheduler.id, scopeTypes[scopeIds.scheduler.id].request.id)

    const navigate = useNavigate();
    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)

    const { setSystemLoading } = useAppContextFeatures()

    const [data, setData] = useState()

    const loadData = useCallback(async (id) => {

        setSystemLoading(true);

        try {

            const { data } = await get({ id })

            console.log('data', data)
            setData(data)

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

    }, [id])

    useEffect(() => {

        loadData(id);

    }, [])

    const RenderStatus = ({ item }) => {

        if (!data) return <></>

        return (
            <StyledCard>
                <Grid container spacing={1}>

                    <Grid item xs={12} sm={12} md={12} sx={{}}>
                        <Grid container spacing={2}>

                            <Grid item xs={12} sm={12} md={2} textAlign={"left"}>
                                <StyledLabel>Status</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={10} textAlign={"left"}>
                                <RequestStatusBadge
                                    item={item}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={2} textAlign={"left"}>
                                <StyledLabel>Response</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={10} textAlign={"left"}>
                                <StyledContent>
                                    {
                                        item?.attempt_result
                                    }
                                </StyledContent>
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderInfo = ({ item }) => {

        if (!data) return <></>

        return (
            <StyledCard sx={{ mt: 0 }}>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={`Information`}
                            subTitle={`Request Detail for the task performed`}
                        />

                    </Grid>

                    <Grid item xs={12}>
                        <StyledDivider />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} sx={{ mt: 2 }}>
                        <Grid container spacing={2}>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Integration Id</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {item?.integration_id}
                                </StyledContent>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Target</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {item?.target}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Module</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {item?.module}
                                </StyledContent>
                            </Grid>


                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Ref</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {item?.request_ref}
                                </StyledContent>
                            </Grid>


                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Action</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {item?.action}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12}>
                                <StyledDivider />
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Destination Id</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {item?.destination_id}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Attempt No.</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {item?.attempt_no}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Attempt Datetime</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {item?.attempt_datetime}
                                </StyledContent>
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderDataSource = ({ item }) => {

        if (!data) return <></>

        // console.log('item?.source_data', item?.source_data)

        let sourceData = {}

        try {
            sourceData = item?.source_data ? JSON.parse(item?.source_data) : {}
        } catch (error) {
            sourceData = {}
            promptMessage(false, `Invalid JSON format for source data`)
        }

        // console.log('sourceData', sourceData)

        return (
            <StyledCard>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={`Source Data`}
                            subTitle={`Data source for task process`}
                        />

                    </Grid>

                    <Grid item xs={12}>
                        <StyledDivider />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} sx={{ mt: 2 }}>
                        <Grid container spacing={2}>

                            <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                                <StyledLabel>Source Id</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={9} textAlign={"left"}>
                                <StyledContent>
                                    {item?.source_id}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                                <StyledLabel>Raw Data</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={9} textAlign={"left"}>
                                {/* <StyledContent>
                                    {item.source_data}
                                </StyledContent> */}

                                {
                                    sourceData &&
                                    <CommonJsonViewer
                                        jsonObject={sourceData}
                                    />
                                }

                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderForm = () => {

        if (!data) return <></>

        const { scheduler_request: item } = data

        return (
            <Grid container spacing={1} textAlign={"left"}>
                <Grid item md={12}>
                    <RenderStatus
                        item={item}
                    />
                </Grid>
                <Grid item md={5}>
                    <RenderInfo
                        item={item}
                    />
                </Grid>
                <Grid item md={7}>
                    <RenderDataSource
                        item={item}
                    />
                </Grid>
            </Grid>
        )
    }

    const getBreadcumbActionMenus = () => {

        let props = []

        // if (isPermissionAllow({ functionType: functionTypes.pageUpdate.id })) {
        //     props.push({
        //         displayText: "Edit Item",
        //         href: getRoute(`product/item/update/${id}`),
        //     })
        // }

        return props

    }

    return (
        <Box>

            {
                getHtmlHead({ routeType, title: headTitles.viewRequest })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={`View Scheduler Request`}
                actionMenus={
                    getBreadcumbActionMenus()
                }
                breadcrumbs={[
                    {
                        displayText: "Scheduler Requests",
                        props: {
                            href: getRoute("settings/scheduler/requests")
                        }
                    },
                    {
                        displayText: `View Scheduler Request #${id}`,
                        props: {
                            color: 'secondary.main'
                        }
                    },
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageView.id }) ?
                    RenderForm()
                    :
                    <CommonRestricted />
            }

        </Box>
    )
}